export default __webpack_public_path__ + "12ec4a4b3f0f72d815b54984cd205f35.svg";